import { render, staticRenderFns } from "./CuratedOptionGroups.vue?vue&type=template&id=7af5e1a6&"
import script from "./CuratedOptionGroups.vue?vue&type=script&lang=js&"
export * from "./CuratedOptionGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports